/* Viretta cart.v2 – the cart page (sections/v2-cart.liquid). Quantity / remove / note / add through the Cart Ajax API, then
   a reload (the page is server-rendered, so totals, »Du sparer« and the set tiles always come from Liquid). The set swap is
   viretta-cart-set-swap.js (Release 1); it fires cart:refresh, which reloads this page. »Fortryd« on the swapped set line. */
(function () {
  var root = document.querySelector('[data-v2-cart]');
  if (!root) return;
  var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function post(url, body) {
    return fetch(base + url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { if (!r.ok) throw new Error(url); return r.json(); });
  }
  function reload() { window.location.reload(); }

  function setQty(line, q) {
    line.classList.add('is-busy');
    post('cart/change.js', { id: line.getAttribute('data-line-key'), quantity: Math.max(0, q) }).then(reload, reload);
  }
  root.addEventListener('click', function (e) {
    var b = e.target.closest('button'); if (!b) return;
    var line = b.closest('.v2-cart__line');
    if (b.hasAttribute('data-v2-qty') && line) {
      var inp = line.querySelector('[data-v2-qtyin]');
      setQty(line, (parseInt(inp.value, 10) || 0) + parseInt(b.getAttribute('data-v2-qty'), 10));
    } else if (b.hasAttribute('data-v2-remove') && line) {
      setQty(line, 0);
    } else if (b.hasAttribute('data-v2-add')) {
      b.setAttribute('aria-busy', 'true');
      post('cart/add.js', { items: [{ id: +b.getAttribute('data-v2-add'), quantity: 1 }] }).then(reload, function () { b.removeAttribute('aria-busy'); });
    }
  });
  root.addEventListener('change', function (e) {
    var t = e.target;
    if (t.hasAttribute('data-v2-qtyin')) setQty(t.closest('.v2-cart__line'), parseInt(t.value, 10) || 0);
    else if (t.hasAttribute('data-v2-note')) post('cart/update.js', { note: t.value });
  });

  /* the set-swap script asks the drawer to redraw – on this page, reload instead */
  document.documentElement.addEventListener('cart:refresh', function () { setTimeout(reload, 50); });

  /* terms before checkout */
  var form = root.querySelector('[data-v2-checkout]');
  if (form) form.addEventListener('submit', function (e) {
    var cb = form.querySelector('[data-v2-terms]'), msg = form.querySelector('[data-v2-termsmsg]');
    if (cb && !cb.checked) { e.preventDefault(); if (msg) msg.hidden = false; cb.focus(); }
  });

  /* »… er skiftet ud med sættet · Fortryd« on the swapped set line (same sessionStorage record as the drawer) */
  try {
    var swap = JSON.parse(sessionStorage.getItem('viretta-set-swap') || 'null');
    if (swap) {
      var line = root.querySelector('.v2-cart__line[data-variant-id="' + swap.setVariant + '"]');
      var u = line && line.querySelector('[data-v2-undo]');
      if (u) { u.querySelector('[data-v2-undotxt]').textContent = (swap.fromTitle || 'Der Artikel') + ' wurde durch das Set ersetzt'; u.hidden = false; }
    }
  } catch (err) {}

  /* »Hører sammen med«: Search & Discovery complementary products, related as fallback */
  var recs = root.querySelector('[data-v2-recs]');
  if (recs && recs.getAttribute('data-product-id')) {
    var pid = recs.getAttribute('data-product-id');
    var get = function (intent) {
      return fetch(base + 'recommendations/products?product_id=' + pid + '&limit=8&intent=' + intent + '&section_id=v2-cart-recs')
        .then(function (r) { return r.ok ? r.text() : ''; });
    };
    var fill = function (html) {
      var d = document.createElement('div'); d.innerHTML = html;
      var items = d.querySelector('.v2-cart__recitems');
      if (!items || !items.children.length) return false;
      recs.querySelector('[data-v2-recgrid]').replaceChildren(items);
      recs.hidden = false; return true;
    };
    get('complementary').then(function (h) { if (!fill(h)) return get('related').then(fill); }).catch(function () {});
  }
})();
